import { render, staticRenderFns } from "./RestaurantTabs.vue?vue&type=template&id=629b5694&"
import script from "./RestaurantTabs.vue?vue&type=script&lang=js&"
export * from "./RestaurantTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports